import React, { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import { Node } from "@tiptap/core";
import { FiBold, FiItalic, FiLink, FiCode } from "react-icons/fi";
import './tip-tap-editor.css';
export const DescriptionList = Node.create({
  name: "descriptionList",
  group: "block",
  content: "descriptionTerm descriptionDetails+",
  parseHTML() {
    return [{ tag: "dl" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["dl", HTMLAttributes, 0];
  },
});
export const DescriptionTerm = Node.create({
  name: "descriptionTerm",
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "dt" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["dt", HTMLAttributes, 0];
  },
});
export const DescriptionDetails = Node.create({
  name: "descriptionDetails",
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "dd" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["dd", HTMLAttributes, 0];
  },
});
export const HorizontalRule = Node.create({
  name: "horizontalRule",
  group: "block",
  atom: true,
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["hr", HTMLAttributes];
  },
});
export default function TipTapEditor({
  value = "",
  onChange,
  minHeight = 160,
}) {
  const [showSource, setShowSource] = useState(false);
  const [sourceValue, setSourceValue] = useState("");
  const editor = useEditor({
    content: value || "<p></p>",
    extensions: [
      StarterKit.configure({
        heading: false,
        blockquote: false,
        codeBlock: false,
        horizontalRule: false,
      }),
      Link.configure({
        openOnClick: false,
      }),
      HorizontalRule,
      DescriptionList,
      DescriptionTerm,
      DescriptionDetails,
    ],

    onUpdate: ({ editor }) => {
      onChange?.(editor.getHTML());
    },
  });
  // synchro externe → éditeur


  useEffect(() => {
    if (!editor) return;
    if (!editor.isFocused) {
      editor.commands.setContent(value || "<p></p>", false);
    }
  }, [value, editor]);


  useEffect(() => {
    if (showSource && editor) {
      setSourceValue(editor.getHTML());
    }
  }, [showSource, editor]);

  if (!editor) return null;
  return (
    <div className="border rounded">
      {/* TOOLBAR */}
      <div className="d-flex gap-1 align-items-center px-2 py-1 border-bottom bg-light">
        <button
          type="button"
          className={`btn btn-sm btn-outline-secondary ${editor.isActive("bold") ? "active" : ""
            }`}
          onClick={() => editor.chain().focus().toggleBold().run()}
          title="Gras"
        >
          <FiBold />
        </button>
        <button
          type="button"
          className={`btn btn-sm btn-outline-secondary ${editor.isActive("italic") ? "active" : ""
            }`}
          onClick={() => editor.chain().focus().toggleItalic().run()}
          title="Italique"
        >
          <FiItalic />
        </button>
        <button
          type="button"
          className={`btn btn-sm btn-outline-secondary ${editor.isActive("link") ? "active" : ""
            }`}
          onClick={() => {
            const previousUrl = editor.getAttributes("link").href;
            const url = prompt("Lien", previousUrl || "");
            if (url === null) return;
            if (url === "") {
              editor.chain().focus().unsetLink().run();
              return;
            }
            editor.chain().focus().setLink({ href: url }).run();
          }}
          title="Lien"
        >
          <FiLink />
        </button>
        <div className="ms-auto">
          <button
            type="button"
            className={`btn btn-sm btn-outline-secondary ${showSource ? "active" : ""
              }`}
            onClick={() => setShowSource(!showSource)}
            title="Code HTML"
          >
            <FiCode />
          </button>
        </div>
      </div>
      {/* CONTENT */}
      <div className="p-3">
        {showSource ? (
          <textarea
            className="form-control"
            style={{ minHeight }}
            value={sourceValue}
            onChange={(e) => {
              const val = e.target.value;
              setSourceValue(val);
              editor.commands.setContent(val, false);
            }}
          />
        ) : (
          <EditorContent
            editor={editor}
            className="tiptap-editor"
            style={{ minHeight }}
          />
        )}
      </div>
    </div>
  );
}